import { render } from "./WarningPanelBase.vue?vue&type=template&id=1969357e&scoped=true"
import script from "./WarningPanelBase.vue?vue&type=script&lang=js"
export * from "./WarningPanelBase.vue?vue&type=script&lang=js"

import "./WarningPanelBase.vue?vue&type=style&index=0&id=1969357e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1969357e"]])

export default __exports__